var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8,2 C11.3084,2 14,4.69163636 14,8.00003636 C14,11.3084364 11.3084,14 8,14 C4.6916,14 2,11.3084364 2,8.00003636 C2,4.69163636 4.6916,2 8,2 Z M8,3.09090909 C5.29309091,3.09090909 3.09090909,5.29316364 3.09090909,8.00003636 C3.09090909,10.7069091 5.29309091,12.9090909 8,12.9090909 C10.7068727,12.9090909 12.9090909,10.7069091 12.9090909,8.00003636 C12.9090909,5.29316364 10.7069091,3.09090909 8,3.09090909 Z M8,6.66666667 C8.36817778,6.66666667 8.66666667,6.92784444 8.66666667,7.25 L8.66666667,7.25 L8.66666667,10.75 C8.66666667,11.0721556 8.36817778,11.3333333 8,11.3333333 C7.63182222,11.3333333 7.33333333,11.0721556 7.33333333,10.75 L7.33333333,10.75 L7.33333333,7.25 C7.33333333,6.92784444 7.63182222,6.66666667 8,6.66666667 Z M8,4.66666667 C8.36760685,4.66666667 8.66666667,4.96586667 8.66666667,5.33363333 C8.66666667,5.70106667 8.36760685,6 8,6 C7.63239315,6 7.33333333,5.70106667 7.33333333,5.33363333 C7.33333333,4.96586667 7.63239315,4.66666667 8,4.66666667 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoOutline);
export default __webpack_public_path__ + "static/media/info-outline.d97586264e43eb38cc7c35bace2b093d.svg";
export { ForwardRef as ReactComponent };